import script from "./TheNavPersonal.vue?vue&type=script&setup=true&lang=js"
export * from "./TheNavPersonal.vue?vue&type=script&setup=true&lang=js"

import "./TheNavPersonal.vue?vue&type=style&index=0&id=5d07c7e5&scoped=true&lang=css"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d07c7e5"]])

export default __exports__